module.exports = __webpack_public_path__ + "static/media/ppt-icon.5cc485b5.svg";